import { useBreakpoint } from '@/common/hooks/use-breakpoint';
import { cn } from '@/shadcn-ui/utils';
import { DotLottieReact, DotLottieReactProps } from '@lottiefiles/dotlottie-react';

/**
 * @see https://developers.lottiefiles.com/docs/dotlottie-player/dotlottie-react/properties/
 */
export interface LottieProps extends Omit<DotLottieReactProps, 'data'> {
  /** Additional class names to apply to the component wrapper */
  className?: string;
}

export interface LottieBaseProps extends LottieProps {
  /** Animation data provided either as a JSON string, ArrayBuffer, or object */
  animationJSON: string | ArrayBuffer | Record<string, unknown>;
}

export function LottieBase({
  animationJSON,
  loop = true,
  autoplay = true,
  playOnHover = false,
  className,
  ...rest
}: LottieBaseProps) {
  const breakpoint = useBreakpoint();

  return (
    <div className={cn(className, 'flex items-center justify-center')}>
      <DotLottieReact
        data={animationJSON}
        loop={loop}
        autoplay={autoplay}
        playOnHover={breakpoint === 'mobile' ? false : playOnHover}
        {...rest}
      />
    </div>
  );
}
